<template>
  <div>
    <h3 :class="headingClass">Hidden preference options</h3>
    <p class="text--secondary">
      Preference controls the website withholds on this plan. Hidden ones
      disappear from the customer's Dietary Preferences page, the signup
      plan step and the meal page's "Change preferences" dialog. Leave empty
      to offer them all (every preference feeds the meal ranking).
    </p>
    <v-select
        multiple chips deletable-chips clearable
        style="max-width: 45em"
        :disabled="disabled"
        :items="options"
        :value="value"
        @input="$emit('input', $event)"
        label="hidden_preferences"
        hint="stored on the plan as hidden_preferences: [keys]"
        persistent-hint
    />
  </div>
</template>

<script>
// the keys the website understands (fed-web-3
// src/v2/pages/use-plan-preferences.js PREFERENCE_KEYS) — keep in sync
export const PREFERENCE_OPTIONS = [
  {value: 'meal_size', text: 'Meal size (Small / Medium / Large)'},
  {value: 'restrictions', text: 'Dietary restrictions (allergies)'},
  {value: 'love', text: 'Ingredients you love'},
  {value: 'hate', text: 'Ingredients you hate'},
  {value: 'goals', text: 'Nutrition goals'},
  {value: 'preset', text: 'Diet preset'},
];

export default {
  name: 'PlanHiddenPreferences',
  props: {
    value: {type: Array, default: () => []},
    disabled: {type: Boolean, default: false},
    headingClass: {type: String, default: ''},
  },
  data() {
    return {options: PREFERENCE_OPTIONS};
  },
};
</script>
